import React from "react";
import toast from "react-hot-toast";
import RichToastContent from "@src/component/RichToastContent";

const HOT_TOAST_BASE_CLASS = "react-hot-toast";
const HOT_TOAST_DEFAULT_CLASS = `${HOT_TOAST_BASE_CLASS} ${HOT_TOAST_BASE_CLASS}--default`;
const HOT_TOAST_RICH_CLASS = `${HOT_TOAST_BASE_CLASS} ${HOT_TOAST_BASE_CLASS}--rich`;

const HOT_TOAST_TYPE_MAP = {
  success: toast.success,
  error: toast.error,
  loading: toast.loading,
};

const resolveHotToastMethod = (type) => HOT_TOAST_TYPE_MAP[type] ?? toast;

export const showToast = ({
  type = "default",
  message,
  title,
  description,
  options = {},
}) => {
  const isRichToast = Boolean(title && description);
  const method = resolveHotToastMethod(type);
  const content = isRichToast ? (
    <RichToastContent title={title} description={description} />
  ) : (
    message
  );

  const defaultOptions = isRichToast
    ? {
        className: HOT_TOAST_RICH_CLASS,
        duration: 6000,
      }
    : {
        className: HOT_TOAST_DEFAULT_CLASS,
      };

  return method(content, {
    ...defaultOptions,
    ...options,
  });
};

export const hotToastClassNames = {
  default: HOT_TOAST_DEFAULT_CLASS,
  rich: HOT_TOAST_RICH_CLASS,
};
